import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import { SchemesTable } from './ListOfServices';
import './Schemes.css';

const Schemes = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['योजना', 'आर्थिक लाभ', 'शिष्यवृत्ती', 'अर्थसहाय्य'],
    en: ['schemes', 'financial benefit', 'scholarship', 'financial assistance']
  });

  const pageHeaderData = {
    title: {
      marathi: 'योजना',
      english: 'Schemes'
    },
    subtitle: {
      marathi: 'मंडळाच्या विविध कल्याणकारी योजना',
      english: 'Various welfare schemes of the board'
    }
  };

  return (
    <div className="schemes-container">
      {/* Page Header */}
      <PageHeader 
        title={pageHeaderData.title}
        subtitle={pageHeaderData.subtitle}
      />

      {/* Main Content */}
      <div className="schemes-content">
        {/* Schemes Table - imported from ListOfServices */}
        <SchemesTable />

        {/* Navigation Buttons */}
        <section className="schemes-navigation">
          <div className="navigation-buttons">
            <Link to="/activities" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'उपक्रम' : 'Activities'}
              </Link>
              <Link to="/programs" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17ZM17 21V10H13V6H7V19H17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'कार्यक्रम' : 'Programs'}
              </Link>
              <Link to="/awards" className="nav-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 2C13.1046 2 14 2.89543 14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 18C13.1046 18 14 18.8954 14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20C10 18.8954 10.8954 18 12 18Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isMarathi() ? 'पुरस्कार' : 'Awards'}
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Schemes;
